import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import BasicButton from '../../Components/Button_Basic';
import BasicCombo from '../../Components/Combo_Basic';
import Input from '../../Components/Input_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
import GridModal from '../../Components/Modal_Grid';
import BasicModal from '../../Components/Modal_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Snackbar from '../../Components/Snackbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Commons from '../../Services/Common/Common';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
function MM10050(props) {
    React.useEffect(() => {
        document.title = '생산BOM관리';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '생산관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>생산BOM관리</strong>" +
            '</h1>';
    }, []);
    const [modalToggle, setModalToggle] = React.useState(false); //품목 설정 팝업
    const [modalToggle1, setModalToggle1] = React.useState(false); //품목 설정 팝업
    const [modalToggle2, setModalToggle2] = React.useState(false);
    const [selectedRowData, setSelectedRowData] = React.useState(null);
    const [selectedModalData, setSelectedModalData] = React.useState(null);
    const [selectedRowData1, setSelectedRowData1] = React.useState(null);
    const [selectedModalData1, setSelectedModalData1] = React.useState(null);
    const [checkInputs, setCheckInputs] = React.useState({
        value: '',
        value1: '',
    });
    let checkPlantCd1 = '';
    let saveWhCd = '';
    let saveWhNm = '';
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    // 상단 그리드 컬럼
    const columnDefs = [
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장
            cellRenderer: Commons.CustomPlantRenderer,
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
        },
        {
            field: 'itemType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemTypeNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목타입
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'lCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Lcategory' && f.lanType === 'COL')[0].lanName
                    : '', //대분류
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'itemBomYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemBomYn' && f.lanType === 'COL')[0].lanName
                    : '', //BOM생성여부
            cellStyle: { textAlign: 'center' },
        },

        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', //기준단가
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
    ];
    const extractKeys = (mappings) => {
        return Object.keys(mappings);
    };
    const lookupValue = (mappings, key) => {
        return mappings[key];
    };
    const comboData = extractKeys(props.inputs.comboList);
    const autoGroupColumnDef = React.useMemo(() => {
        return {
            minWidth: 300,
            cellRendererParams: {
                footerValueGetter: (params) => {
                    return 'Grand Total';
                },
            },
        };
    }, []);
    //하단 그리드
    const columnDefs1 = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: 'plantCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장코드
            hide: true,
        },
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장코드
            cellRenderer: Commons.CustomPlantRenderer,
        },
        // {
        //   field: "orSeq",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_Seq" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //순번
        //   cellStyle: { textAlign: "center" },
        // },
        //창고
        {
            field: 'whCd2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            hide: true,
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            minWidth: 300,
            cellRenderer: (value) => {
                if (value.data == undefined || value.data == 'undefined' || value.data == null || !value) {
                    //value가 없을때
                } else {
                    return value.data && value.data.bomItemCd ? (
                        <span style={{ color: 'black' }}>{value.data.itemNm}</span>
                    ) : value.data.no == null ? (
                        <BasicButton name="설정하기" onClick={() => AuthGroupSettingClicked1(value)} />
                    ) : (
                        <span style={{ color: 'black' }}>{}</span>
                    );
                }
            },
        },
        {
            field: 'itemType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemTypeNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목타입
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', //기준단가
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'bomItemUseage',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BomItemUseage' && f.lanType === 'COL')[0].lanName
                    : '', //소요량
            cellStyle: { textAlign: 'right' },
            editable: true,
            cellDataType: 'number',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'itemTypeNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '', //품목단위
            // cellStyle: { textAlign: "right" },
        },
        {
            field: 'totalAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_TotalAmt' && f.lanType === 'COL')[0].lanName
                    : '', //총금액
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',

            cellDataType: 'number',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value
                          .toFixed(4)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '', //비고
            editable: true,
            minWidth: 300,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'bomItemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
    ];
    // 품목 설정 그리드
    const AuthGroupGridColumnDef = [
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장
            cellRenderer: Commons.CustomPlantRenderer,
        },
        //창고
        {
            field: 'whCd2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            hide: true,
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        // {
        //   field: "itemCd",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //품목코드
        // },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            cellRenderer: (e) => {
                return e.data.itemNm ? (
                    <span style={{ color: 'black' }}>{e.data.itemNm}</span>
                ) : e.data.no == null ? (
                    <BasicButton name="설정하기" onClick={() => setModalToggle1(true)} />
                ) : (
                    <span style={{ color: 'black' }}>{}</span>
                );
            },
            minWidth: 200,
        },
        {
            field: 'itemType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemTypeNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목타입
        },
        //발주수량
        {
            field: 'stockAddQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            aggFunc: 'sum',
            minWidth: 100,
        },
        //재고수량(BOM)
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Calculate_Qty' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            aggFunc: 'sum',
            minWidth: 100,
        },

        //단위
        {
            field: 'itemUnit',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 100,
        },
        // {
        //   field: "itemStdAmt",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //         (f) => f.lanId === "Col_ItemStdAmt" && f.lanType === "COL"
        //       )[0].lanName
        //       : "", //기준단가
        //   valueFormatter: (params) => {
        //     var formatted = params.value
        //       ? params.value
        //         .toString()
        //         .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
        //       : "";
        //     return formatted;
        //   },
        // },
        // //금액
        // {
        //   field: "soItemAmt",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_SoItemAmt" && f.lanType === "COL"
        //         )[0].lanName
        //       : "",
        //   cellStyle: { textAlign: "right" },
        //   valueFormatter: (params) => {
        //     var formatted = params.value
        //       ? params.value
        //           .toString()
        //           .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
        //       : "";
        //     return formatted;
        //   },
        //   aggFunc: "sum",
        //   minWidth: 100,
        // },
    ];
    // 품목 설정 그리드
    const AuthGroupGridColumnDef1 = [
        {
            field: 'plantNm',
            headerName: '사업자명',
            cellRenderer: Commons.CustomPlantRenderer,
        },
        {
            field: 'itemCd',
            headerName: '품목코드',
        },
        {
            field: 'itemNm',
            headerName: '품목명',
            minWidth: 300,
        },
        {
            field: 'itemUnitNm',
            headerName: '품목단위',
            minWidth: 100,
        },
        {
            field: 'itemStd',
            headerName: '규격',
            editable: true,
        },
        {
            field: 'itemFormula',
            headerName: '계산식',
            hide: true,
        },
        // {
        //   field: "itemUnitNm",
        //   headerName: "단위",
        //   editable: true,
        //   cellEditor: "agSelectCellEditor",
        //   cellEditorParams: {
        //     values: props.inputs.comboUnit,
        //   },
        //   valueParser: (params) => {
        //     return props.inputs.comboValue;
        //   },
        //   valueFormatter: (params) => {
        //     if (params.value == undefined) {
        //       return null;
        //     } else {
        //       return params.value.name;
        //     }
        //   },
        // },
        {
            field: 'itemStdAmt',
            headerName: '단가',
            editable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(0)
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
    ];
    const AuthGroupSettingClicked1 = (_data) => {
        // setSelectedRowData1({ ..._data.data });
        setModalToggle(true);
        // setCheckInputs({
        //   ...checkInputs,
        //   value1: "",
        // });
        // props.setAuthGroupGridRowData1([]);
    };

    const onCellClicked = (e) => {
        const selected = e.data;
        props.setBomStdAmt('');
        props.SearchItemBomLogic(selected.itemCd);
        props.setSaveItemCd(selected.itemCd);
        props.setBomYn(selected.itemBomYn);
        props.setCheckPlantCd(selected.plantCd);
        props.setInputs({
            ...props.inputs,
            itemCd: selected.itemCd,
            plantCd: selected.plantCd,
            itemNm: selected.itemNm,
            itemType: selected.itemType,
            itemBomYn: selected.itemBomYn,
            createId: selected.createId,
            updateId: selected.updateId,
            itemStdAmt: selected.itemStdAmt,
        });
        checkPlantCd1 = selected.plantCd;
    };

    return (
        <div
            style={{
                //display: "flex",
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '100%', height: '400px' }}>
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '335px' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {/* 상단 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="MM10050"
                            target="F01"
                            refreshNone="none"
                            selectFunc={() => {
                                props.SearchLogic();
                            }}
                        />
                    </Card>
                    {/* 상단 그리드 */}
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 150,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        rowData={props.rowData}
                        rowSelection="single"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        onCellClicked={onCellClicked}
                    />
                </div>
            </div>
            <div style={{ width: '100%', height: '370px' }}>
                <div>
                    {' '}
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Autocomplete
                            key={'combo'}
                            freeSolo
                            id={props.inputs.copyItemList.id}
                            disableClearable
                            sx={{ width: '200px' }}
                            options={props.inputs.copyItemList}
                            getOptionLabel={(option) => option.label || ''}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}
                                        label={'품목코드/명'}
                                        InputProps={{
                                            ...params.InputProps,
                                            type: 'search',
                                        }}
                                    />
                                );
                            }}
                            onInputChange={(event, value) => {
                                const selectedItem = props.inputs.copyItemList.find((item) => value === item.label);
                                if (selectedItem) {
                                    props.setInputs({
                                        ...props.inputs,
                                        copyItemCd: selectedItem.id,
                                    });
                                }
                            }}
                            onChange={(e) => {
                                props.inputs.copyItemList.map((item, index) => {
                                    if (
                                        e.target.childNodes[0]
                                            ? e.target.childNodes[0].nodeValue === item.label
                                            : e.target.value === item.label
                                    ) {
                                        props.setInputs({
                                            ...props.inputs,
                                            copyItemCd: item.id,
                                        });
                                    }
                                });
                            }}
                            value={props.inputs.copyItemList}
                        />
                        <BasicButton
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Copy' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '' //복사
                            }
                            onClick={(e) => props.Copy()}
                        />
                        {/* 하단 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="MM10050"
                            target="G01"
                            refreshNone="none"
                            addFunc={(e) => {
                                if (props.bomYn == 'Y') {
                                    gridRef1.current.api.setRowData([{ check: '' }, ...props.rowData1]);
                                    // props.setRowData1([
                                    //   ...props.rowData1,
                                    //   {
                                    //     // plantCd: checkPlantCd1,
                                    //   },
                                    // ]);
                                } else {
                                    props.setSnackbars({
                                        toggle: true,
                                        type: 'info',
                                        message: props.lanData.filter(
                                            (f) => f.lanId === 'Snack_CheckBomYn' && f.lanType === 'SNACK'
                                        )[0].lanName,
                                    });
                                }
                            }}
                            saveFunc={() => props.SaveConfirm('save')}
                            deleteFunc={() => {
                                props.DeleteConfirm();
                            }}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '360px' }}>
                        {/* 하단 그리드 */}
                        <AgGridReact
                            ref={gridRef1}
                            animateRows={true}
                            columnDefs={columnDefs1}
                            groupIncludeFooter={true}
                            groupIncludeTotalFooter={true}
                            // autoGroupColumnDef={autoGroupColumnDef}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 150,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            onCellValueChanged={(e) => {
                                let rowIndex = e.rowIndex;
                                if (e.oldValue !== e.newValue) {
                                    if (e.data.check === '') {
                                        props.setRowData1([
                                            {
                                                plantCd: props.checkPlantCd,
                                                processCd: e.data.processNm.value,
                                                totalAmt: e.data.bomItemUseage * e.data.itemStdAmt,
                                            },
                                            ...props.rowData1,
                                        ]);
                                        props.setChangedRowData1((current) => [...current]);
                                    }
                                    props.rowData1.map((item, index) => {
                                        if (index === rowIndex) {
                                            item.plantCd = props.checkPlantCd;
                                            item.itemCd = props.saveItemCd;
                                            item.totalAmt = e.data.bomItemUseage * e.data.itemStdAmt;
                                        }
                                    });
                                    props.setChangedRowData1((current) => [...current]);
                                }
                            }}
                            rowData={props.rowData1}
                            rowSelection="single"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData)
                            }
                            getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                        />
                    </div>
                </div>
            </div>
            {/* 품목 설정 팝업 */}
            {modalToggle && (
                <GridModal
                    conditions={[
                        {
                            type: 'input',
                            name: '품목 코드',
                            value: checkInputs.value,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    value: e.target.value,
                                });
                            },
                            onClick: (e) => {
                                // document.getElementsByName("품목코드/명").focus;
                            },
                            onKeyDown: (e) => {
                                props.GetItemList(checkInputs.value);
                            },
                        },
                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name: '조회',
                            onClick: (e) => {
                                props.GetItemList(checkInputs.value);
                            },
                        },
                    ]}
                    name="품목 설정"
                    onClose={() => setModalToggle(false)}
                    gridColumn={AuthGroupGridColumnDef}
                    containerStyle={{ width: '80%' }}
                    gridRowData={props.authGroupGridRowData}
                    buttonName1="저장"
                    buttonName2="확인"
                    notButton="3"
                    gridRowSelection={'multiple'}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                whCd: e[i].whCd,
                                plantCd: e[i].plantCd,
                                itemCd: e[i].itemCd,
                                itemNm: e[i].itemNm,
                                itemType: e[i].itemType,
                                itemStdAmt: e[i].itemStdAmt,
                                updateId: e[i].updateId,
                                itemUnitNm: e[i].itemUnitNm,
                                orSeq: e[i].orSeq,
                            });
                        }
                        setSelectedModalData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    addLogic={() => {
                        setModalToggle1(true);
                    }}
                    searchLogic={() => {
                        let a = gridRef1.current.props.rowData;
                        let index = -1;
                        if (selectedModalData !== null) {
                            for (let i = 0; i < props.authGroupGridRowData.length; i++) {
                                if (
                                    props.authGroupGridRowData[i].itemCd === selectedModalData[0].itemCd &&
                                    props.authGroupGridRowData[i].whCd === selectedModalData[0].whCd
                                ) {
                                    index = i;
                                }
                            }
                            if (props.authGroupGridRowData.length > 0) {
                                props.setRowData1([
                                    {
                                        plantCd: props.authGroupGridRowData[index].plantCd,
                                        bomItemCd: props.authGroupGridRowData[index].itemCd,
                                        itemNm: props.authGroupGridRowData[index].itemNm,
                                        itemType: props.authGroupGridRowData[index].itemType,
                                        itemStdAmt: props.authGroupGridRowData[index].itemStdAmt,
                                        updateId: props.authGroupGridRowData[index].updateId,
                                        orSeq: props.authGroupGridRowData[index].orSeq,
                                        itemTypeNm: props.authGroupGridRowData[index].itemUnit,
                                        whNm: props.authGroupGridRowData[index].whNm,
                                        whCd: props.authGroupGridRowData[index].whCd,
                                    },
                                    ...props.rowData1,
                                ]);
                            }
                        }
                    }}
                    execCLosed="0"
                    execLogic={() => {
                        props.CreateStock(
                            props.authGroupGridRowData[0].itemCd,
                            props.authGroupGridRowData[0].whCd,
                            props.authGroupGridRowData[0].plantCd
                        );
                    }}
                />
            )}

            {/*재고생성 */}
            {modalToggle1 && (
                <BasicModal
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter(
                                  (f) => f.lanId === 'Fom_InventoryGeneration' && f.lanType === 'FORM'
                              )[0].lanName
                            : '' //재고생성
                    }
                    onClose={() => setModalToggle1(false)}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    execLogic={() => {
                        props.StockHelper();
                    }}
                >
                    <FormGroup
                        columnCount={2}
                        datas={[
                            {
                                type: 'button',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_ItemCd' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //품목코드(설정하기)
                                btnName:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_Setting' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : '',
                                onClick: (e) => {
                                    setModalToggle2(true);
                                },
                            },
                            //품목명
                            {
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_ItemNm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '',
                                value: props.checkInputs.itemNm,
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        itemNm: e.target.value,
                                    });
                                },
                                readOnly: true,
                            },
                            {
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_AdditionalQuantity' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //추가수량
                                value: props.checkInputs.itemQty,
                                inputType: 'number',
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        itemQty: e.target.value,
                                    });
                                },
                                readOnly: true,
                            },
                            //창고
                            {
                                type: 'combo',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter((f) => f.lanId === 'Fom_WhNm' && f.lanType === 'FORM')[0]
                                              .lanName
                                        : '',
                                value: props.checkInputs.whCd,
                                combos: props.whType,
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        whCd: e,
                                    });
                                },
                            },
                        ]}
                    />
                </BasicModal>
            )}
            {modalToggle2 && (
                <GridModal
                    //품목타입
                    conditions={[
                        {
                            type: 'combo',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Fom_ItemTypeNm' && f.lanType === 'FORM'
                                      )[0].lanName
                                    : '',
                            combos: props.checkInputs.comboList,
                            value: props.checkInputs1.itemType,
                            onChange: (e) => {
                                props.setCheckInputs1({
                                    ...props.checkInputs1,
                                    itemType: e,
                                });
                            },
                        },
                        //품목코드/명
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM'
                                      )[0].lanName
                                    : '',
                            value: props.checkInputs1.value1,
                            onChange: (e) => {
                                props.setCheckInputs1({
                                    ...props.checkInputs1,
                                    value1: e.target.value,
                                });
                            },
                            onClick: (e) => {
                                // document.getElementsByName("품목코드/명").focus;
                            },
                            onKeyDown: (e) => {
                                props.GetCommonItemList(props.checkInputs1.value1);
                            },
                        },
                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '',
                            onClick: (e) => {
                                props.GetCommonItemList(props.checkInputs1.value1);
                            },
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM')[0]
                                  .lanName
                            : ''
                    }
                    onClose={() => setModalToggle2(false)}
                    gridColumn={AuthGroupGridColumnDef1}
                    gridRowData={props.authGroupGridRowData1}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Fom_ItemCdSetting' && f.lanType === 'FORM')[0]
                                  .lanName
                            : ''
                    }
                    onCellValueChanged={(e) => {
                        GridFunctions.onCellValueChanged(e, AuthGroupGridColumnDef1, props.setChangedRowData1);
                    }}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                whCd: e[i].whCd,
                                plantCd: e[i].plantCd,
                                itemCd: e[i].itemCd,
                                itemNm: e[i].itemNm,
                                itemStd: e[i].itemStd,
                                itemUnit: e[i].itemUnit,
                                itemUnitNm: e[i].itemUnitNm,
                                itemStdAmt: e[i].itemStdAmt,
                                poItemCost: e[i].poItemCost,
                                itemVatYn: e[i].itemVatYn,
                                itemFormula: e[i].itemFormula,
                                itemUnitNm: e[i].itemUnitNm,
                            });
                        }
                        setSelectedModalData1(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execCLosed="1"
                    execLogic={(e) => {
                        props.setCheckInputs({
                            ...props.checkInputs,
                            itemCd: selectedModalData1[0].itemCd,
                            itemNm: selectedModalData1[0].itemNm,
                            plantCd: selectedModalData1[0].plantCd,
                            itemUnitNm: selectedModalData1[0].itemUnitNm,
                        });
                    }}
                />
            )}
        </div>
    );
}
export default MM10050;
